import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as Common from '_common';
import * as Components from '_components';
import * as Utils from '_utils';
export function DashboardButton(props) {
    const dsContext = Components.useDashboardContext();
    const setMode = dsContext?.setMode || (() => { });
    return (_jsx(Components.Button, { tileSize: props.size || Components.TileSize.SmallLong, isActive: props.isActive, onClick: () => setMode(props.id), children: props.children }));
}
export function RenderDashboardRoomButton(component, index) {
    return _jsx(DashboardRoomButton, { name: component.properties.name, setMode: () => { } });
}
export function DashboardRoomButton(props) {
    const context = Common.useSpaContext();
    const roomInfo = context?.state ? context?.state[props.name] : {};
    function isWindowOpened(windowClosed) {
        if (windowClosed === undefined || windowClosed === null) {
            return false;
        }
        return !Utils.toBool(windowClosed);
    }
    function getDetails() {
        const details = [];
        if (roomInfo?.temp) {
            details.push(_jsx("div", { children: formatTemperature(roomInfo?.temp) }, "1"));
        }
        if (roomInfo?.co2 >= 800) {
            details.push(_jsxs("div", { children: ["CO2: ", formatNumber(roomInfo.co2), " ppm"] }, "2"));
        }
        if (roomInfo?.humidity >= 80) {
            details.push(_jsxs("div", { children: ["Humidity: ", formatNumber(roomInfo.humidity), "%"] }, "3"));
        }
        if (details.length < 3 && isWindowOpened(roomInfo?.window?.closed)) {
            details.push(_jsx("div", { children: _jsx(Common.MLT, { en: "Window opened", cs: "Okno je otev\u0159en\u00E9" }) }, "4"));
        }
        if (details.length < 3 && isWindowOpened(roomInfo?.northWindow?.closed)) {
            details.push(_jsx("div", { children: _jsx(Common.MLT, { en: "North window opened", cs: "Severn\u00ED okno je otev\u0159en\u00E9" }) }, "5"));
        }
        if (details.length < 3 && isWindowOpened(roomInfo?.southWindow?.closed)) {
            details.push(_jsx("div", { children: _jsx(Common.MLT, { en: "South window opened", cs: "Ji\u017En\u00ED okno je otev\u0159en\u00E9" }) }, "6"));
        }
        if (details.length < 3 && isWindowOpened(roomInfo?.kitchenWindow?.closed)) {
            details.push(_jsx("div", { children: _jsx(Common.MLT, { en: "Kitchen window opened", cs: "Kuchy\u0148sk\u00E9 okno je otev\u0159en\u00E9" }) }, "7"));
        }
        return details;
    }
    const details = getDetails();
    function getTileSize() {
        if (details.length === 0) {
            return Components.TileSize.SmallLong;
        }
        return details.length > 1 ? Components.TileSize.Long : Components.TileSize.LongThin;
    }
    return (_jsx(DashboardButton, { id: props.name, size: getTileSize(), children: _jsxs("div", { children: [_jsx("h1", { children: GetRoomName(props.name) }), details] }) }));
}
function formatTemperature(temp) {
    return formatNumber(temp) + '°C';
}
function formatNumber(value) {
    if (value === undefined) {
        return 'N/A';
    }
    if (typeof value === 'string') {
        value = Number.parseFloat(value);
    }
    return Intl.NumberFormat().format(value);
}
export function RenderDashboardRoomFull(component, index) {
    return _jsx(RoomFullWidtget, { name: component.properties.name });
}
export function RoomFullWidtget(props) {
    const context = Common.useSpaContext();
    const roomInfo = context?.state ? context?.state[props.name] : {};
    function formatBlind(blind, windowName) {
        if (!blind) {
            return _jsx(_Fragment, {});
        }
        const signs = [{ value: Number.parseInt(blind.pos1), text: '' }];
        const blindName = getBlindName(props.name, windowName);
        async function sendCommand(cmd) {
            //setMakingRequest(true);
            try {
                await Utils.Ajax.post('/house_api/command/' + blindName + '/' + cmd);
            }
            catch (error) {
                // TODO what now?
                console.error(error);
            }
            //setMakingRequest(false);
        }
        return (_jsxs(_Fragment, { children: [_jsx("br", {}), _jsx(Components.Progress, { direction: Components.ProgressDirection.TopToBottom, value: blind.pos, max: blind.max, customSigns: signs }), _jsxs(Components.BtnGroup, { type: Components.BtnGroupType.Horizontal, small: true, children: [_jsx(Components.Button, { onClick: () => {
                                sendCommand('open');
                            }, children: "Open" }), _jsx(Components.Button, { onClick: () => {
                                sendCommand('ToPos1');
                            }, children: "Pos 1" }), _jsx(Components.Button, { onClick: () => {
                                sendCommand('close');
                            }, children: "Close" }), _jsx(Components.Button, { onClick: () => {
                                sendCommand('stop');
                            }, children: "Stop" })] })] }));
    }
    function formatWindow(window, windowName, title) {
        if (!window) {
            return _jsx(_Fragment, {});
        }
        return (_jsx(_Fragment, { children: _jsxs(Components.Property, { title: _jsx(Common.MLT, { text: title }), children: [window.closed ? (_jsx(Common.MLT, { cs: "Zav\u0159eno", en: "Closed" })) : (_jsx(Common.MLT, { cs: "Otev\u0159eno", en: "Opened" })), formatBlind(window.blind, windowName)] }) }));
    }
    function formatLights() {
        if (props.name !== 'bedRoom') {
            return _jsx(_Fragment, {});
        }
        function getLight(light, id, name) {
            return (_jsx(Components.Property, { title: _jsx(Common.MLT, { text: name }), children: _jsxs(Components.BtnGroup, { type: Components.BtnGroupType.Horizontal, children: [_jsx(Components.Button, { onClick: () => {
                                Utils.Ajax.post(`/house_api/command/${id}/off`);
                            }, children: "Off" }), _jsx(Components.Progress, { max: 256, value: light?.value ?? 0, onClick: (value) => {
                                Utils.Ajax.post(`/house_api/command/${id}/${value}`);
                            } }), _jsx(Components.Button, { onClick: () => {
                                Utils.Ajax.post(`/house_api/command/${id}/on`);
                            }, children: "On" })] }) }));
        }
        return (_jsxs(_Fragment, { children: [getLight(roomInfo?.light1, 'Light1', '1'), getLight(roomInfo?.light2, 'Light2', '2')] }));
    }
    return (_jsxs(_Fragment, { children: [_jsx("h1", { children: GetRoomName(props.name) }), _jsx(Components.Property, { title: _jsx(Common.MLT, { cs: "Teplota", en: "Temperature" }), children: formatTemperature(roomInfo?.temp) }), _jsxs(Components.Property, { title: _jsx(Common.MLT, { cs: "Vlhkost", en: "Humidity" }), children: [formatNumber(roomInfo?.rh), "%"] }), _jsxs(Components.Property, { title: _jsx(Common.MLT, { cs: "CO2", en: "CO2" }), children: [formatNumber(roomInfo?.co2), " ppm"] }), formatLights(), formatWindow(roomInfo?.window, 'window', {
                cs: 'Okno',
                en: 'Window',
            }), formatWindow(roomInfo?.northWindow, 'northWindow', {
                cs: 'Severní okno',
                en: 'North window',
            }), formatWindow(roomInfo?.southWindow, 'southWindow', {
                cs: 'Jižní okno',
                en: 'South window',
            }), formatWindow(roomInfo?.kitchenWindow, 'kitchenWindow', {
                cs: 'Kuchyňské okno',
                en: 'Kitchen window',
            })] }));
}
export function GetRoomName(name) {
    switch (name) {
        case 'livingRoom':
            return _jsx(Common.MLT, { en: "Living room", cs: "Ob\u00FDv\u00E1k" });
        case 'bedRoom':
            return _jsx(Common.MLT, { en: "Bedroom", cs: "Lo\u017Enice" });
        case 'office':
            return _jsx(Common.MLT, { en: "Office", cs: "Kancel\u00E1\u0159" });
        case 'laundry':
            return _jsx(Common.MLT, { en: "Laundry", cs: "Pr\u00E1delna" });
        case 'bathroom':
            return _jsx(Common.MLT, { en: "Bathroom", cs: "Koupelna" });
        case 'vestibule':
            return _jsx(Common.MLT, { en: "Vestibule", cs: "P\u0159eds\u00ED\u0148" });
        case 'northRoom':
            return _jsx(Common.MLT, { en: "North room", cs: "Severn\u00ED pokoj" });
        case 'southRoom':
            return _jsx(Common.MLT, { en: "South room", cs: "Ji\u017En\u00ED pokoj" });
        case 'upperHallway':
            return _jsx(Common.MLT, { en: "Upper hallway", cs: "Horn\u00ED chodba" });
        default:
            return name;
    }
}
function getBlindName(roomName, windowName) {
    switch (roomName) {
        case 'office':
            return 'officeBlind';
        case 'vestibule':
            return 'vestibuleBlind';
        case 'northRoom':
            return 'northRoomBlind';
        case 'southRoom':
            return 'southRoomBlind';
        case 'upperHallway':
            return 'upperHallWayBlind';
        case 'livingRoom':
            switch (windowName) {
                case 'southWindow':
                    return 'livingRoomSouthBlind';
                case 'northWindow':
                    return 'livingRoomNorthBlind';
                case 'kitchenWindow':
                    return 'kitchenBlind';
                default:
                    return null;
            }
        default:
            return null;
    }
}
export function RenderHotWaterPumpButtonRender(component, index) {
    return _jsx(HotWaterPumpButton, {});
}
function HotWaterPumpButton() {
    const context = Common.useSpaContext();
    const hotWaterPump = context?.state?.hotWaterPump || {};
    function getDetails() {
        if (Utils.toBool(hotWaterPump.on)) {
            return (_jsxs(_Fragment, { children: [_jsx("progress", { value: hotWaterPump.offIn, max: hotWaterPump.cfg }), hotWaterPump.offIn] }));
        }
        else {
            return (_jsx(Components.Refresh, { afterMs: 500, children: _jsx(Common.MLT, { text: Utils.since(Utils.toDate(hotWaterPump.lOff)) }) }));
        }
    }
    function toggle() {
        if (Utils.toBool(hotWaterPump.on)) {
            // turn off
            Utils.Ajax.post('/house_api/command/hotWaterPump/stop');
        }
        else {
            // turn on
            Utils.Ajax.post('/house_api/command/hotWaterPump/start');
        }
    }
    return (_jsx(Components.Button, { tileSize: Components.TileSize.LongThin, onClick: () => toggle(), children: _jsxs("div", { children: [_jsx("h1", { children: _jsx(Common.MLT, { en: "Hot water", cs: "Tepl\u00E1 voda" }) }), getDetails()] }) }));
}
export function RenderProcessButton(component, index) {
    function runProcess() {
        Utils.Ajax.post(`/house_api/process/${component.properties.id}/start`);
    }
    return (_jsx(Components.Button, { tileSize: Components.TileSize.SmallLong, onClick: () => runProcess(), children: _jsx("div", { children: _jsx("h1", { children: _jsx(Common.MLT, { en: component.properties.id, cs: component.properties.id }) }) }) }));
}
